<div class="group-filter">
  <div class="chevron"
       [class.active]="getPrevGroupId() !== null"
       [class.inactive]="getPrevGroupId() === null"
       (click)="getPrevGroupId() && groupChange(getPrevGroupId())">
    &lt;
  </div>

  <div class="group-name-container">
    @for (group of groups(); track group.group_id) {
      <div class="group-name" [class]="getSlideClass(group.group_id)">
        {{ 'nav.group' | translate }} {{group.group_id}}
      </div>
    }
  </div>

  <div class="chevron"
       [class.active]="getNextGroupId() !== null"
       [class.inactive]="getNextGroupId() === null"
       (click)="getNextGroupId() && groupChange(getNextGroupId())">
    &gt;
  </div>
</div>
